import { NavLink } from "react-router-dom";
import ComprarEntradas from "../components/evento/ComprarEntradas";
import { useState } from "react";
import { PATH_EVENTO_PRODUCTION } from "../../const/PATH";
import OfComprarEntradas from "../components/evento/OfComprarEntradas";
import { upcomingDate } from "../../utils/EventoUtils";
import { Helmet } from "react-helmet-async";
import SelectEntrada from "../utils/SelectEntrada";

const Entrada = ({
  setStep,
  step,
  entradas,
  onClick,
  comission,
  form,
  evento,
  label,
  me,
  membresia,
  loading,
  stock,
}) => {
  const [image, setImage] = useState(
    `${PATH_EVENTO_PRODUCTION}${evento?.imagen}`
  );
  const manejarError = () => {
    setImage("/assets/img/eventos/imageNotFound.svg");
  };

  const fichaTecnica = (ficha_tecnica) => {
    if (typeof ficha_tecnica == "string") {
      return Object.keys(JSON.parse(ficha_tecnica)).map((key, index) => {
        return (
          <p className="mb-2" key={index}>
            <strong>{key}</strong> {JSON.parse(ficha_tecnica)[key]}
          </p>
        );
      });
    } else {
      return Object.keys(ficha_tecnica).map((key, index) => {
        return (
          <p className="mb-2" key={index}>
            <strong>{key}</strong> {ficha_tecnica[key]}
          </p>
        );
      });
    }
  };

  const links = (links) => {
    if (typeof links == "string") {
      return Object.keys(JSON.parse(links)).map((key, index) => (
        <div className="mb-3">
          <a href={JSON.parse(links)[key]} className="mb-2" target="_blank">
            {key}
          </a>
        </div>
      ));
    } else {
      return Object.keys(links).map((key, index) => (
        <div className="mb-3">
          <a href={links[key]} className="mb-2" target="_blank">
            {key}
          </a>
        </div>
      ));
    }
  };

  return (
    <main className="m-0 min-vh-100" style={{ paddingTop: "100px" }}>
      <Helmet>
        {/* Open Graph (Facebook, LinkedIn, Instagram, WhatsApp) */}
        <meta property="og:title" content={evento?.nombre} />
        <meta property="og:description" content={evento?.descripcion} />
        <meta property="og:image" content={image} />
        <meta
          property="og:url"
          content={`https://antesala.com/entrada/${evento?.slug}`}
        />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content={"Antesala"} />
        <meta property="og:locale" content="es_ES" />

        {/* Twitter Cards */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={evento?.nombre} />
        <meta name="twitter:description" content={evento?.descripcion} />
        <meta name="twitter:image" content={image} />
        <meta name="twitter:site" content="@MiCuentaTwitter" />

        {/* Título dinámico */}
        <title>{evento?.nombre}</title>
      </Helmet>
      <section className="bg-gris-claro pt-4 pb-5 w-100 ">
        <div className="container-md">
          <div className="row">
            <div className="col-md-12 mb-3 d-none">
              <NavLink
                to="/"
                className="btn btn-outline-dark py-3"
                style={{ borderRadius: "20px" }}
              >
                <i className="bi bi-chevron-left"></i>
                Volver
              </NavLink>
            </div>
            <div className="col-md-6 wow bounceInLeft d-none d-md-block">
              <div
                className="overflow-hidden"
                style={{
                  position: "relative",
                  width: "100%",
                  paddingTop: "100%",
                }}
              >
                <img
                  src={image}
                  alt=""
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>
            </div>
            <div className="col-md-6">
              {evento?.categorias.map((categoria) => (
                <p
                  className="Grifter bg-naranja text-white px-2 py-2 d-inline-block me-1"
                  style={{ borderRadius: "10px", fontSize: "12px" }}
                >
                  {categoria.nombre}
                </p>
              ))}
              <h3 className="Grifter GothamBold fs-4 text-uppercase wow bounceInUp">
                {evento.nombre}
              </h3>
              <h4 className="Grifter text-uppercase fs-6 mb-2 wow bounceInUp">
                {evento.nombre_grupo}
              </h4>
              <div
                className="border d-block d-md-none overflow-hidden"
                style={{
                  position: "relative",
                  width: "100%",
                  paddingTop: "100%",
                }}
              >
                <img
                  src={image}
                  className="w-100 h-100"
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0, objectFit: "cover" }}
                  alt=""
                  onError={manejarError}
                />
              </div>

              <span className="fw-bold" style={{ fontSize: "10px" }}>
                Proxima función
              </span>

              <select
                className="form-select"
                aria-label="Default select example"
                name="add-date"
                onChange={(e) => {
                  const selectedOption =
                    e.target.options[e.target.selectedIndex];
                  onClick(e, {
                    select: e.target.value,
                    stock: selectedOption.getAttribute("data-stock"),
                    hora: selectedOption.getAttribute("data-hora"),
                  });
                }}
              >
                <option selected>Selecciona una fecha valida</option>
                {evento.fechasJSON.map((json) => {
                  return json.fechas.map((fecha) => {
                    if (upcomingDate(fecha, json.hora)) {
                      return (
                        <option
                          value={fecha}
                          data-stock={json.stock}
                          data-hora={json.hora}
                        >{`${fecha} Hora: ${json.hora}`}</option>
                      );
                    }
                  });
                })}
              </select>

              <ul className="list-group mt-3 wow bounceInUp">
                <span
                  className="Grifter fw-bold mb-2"
                  style={{ fontSize: "10px" }}
                >
                  LUGAR
                </span>
                <li className="GothamLight text-uppercase d-flex align-items-center mb-2 fw-bold">
                  <i className="bi bi-buildings fw-bold me-2"></i>
                  {evento.nombre_sitio}
                </li>
                <span
                  className="Grifter fw-bold mb-2"
                  style={{ fontSize: "10px" }}
                >
                  UBICACIÓN
                </span>
                <li className="GothamLight text-uppercase d-flex mb-2 fw-bold">
                  <i className="bi bi-geo-alt-fill me-2 fw-bold"></i>
                  {`${evento.direccion}, ${evento.localidad} ${evento.provincia}`}
                </li>
              </ul>
              <span className="fw-bold" style={{ fontSize: "10px" }}>
                PRECIO DESDE
              </span>
              <div className="fs-3 fw-bold text-custom-naranja">
                {SelectEntrada(evento?.entradas)}
                <span className="fs-6 fw-normal d-none">{`(+${evento.comisiones.tasa}% por compra online)`}</span>
              </div>
              <div>
                <ul className="list-group list-group-horizontal">
                  <li
                    className="d-flex text-nowrap list-group-item border-0 fw-bold bg-transparent p-0 py-2 px-2"
                    style={{ fontSize: "12px" }}
                  >
                    <i className="bi bi-clock me-1"></i>
                    {`${evento.duracion} min`}
                  </li>

                  {evento.atp == "SI" ? (
                    <li
                      className="d-flex list-group-item border-0 fw-bold bg-transparent p-0 py-2 px-2"
                      style={{ fontSize: "12px" }}
                    >
                      <i className="bi bi-person-standing me-1"></i>
                      ATP
                    </li>
                  ) : (
                    ""
                  )}

                  {evento.infancias == "SI" ? (
                    <li
                      className="d-flex  list-group-item border-0 fw-bold bg-transparent p-0 py-2 px-2"
                      style={{ fontSize: "12px" }}
                    >
                      <i className="bi bi-person-standing me-1"></i>
                      INFANCIAS
                    </li>
                  ) : (
                    ""
                  )}

                  {evento.infancias == "SI" ? (
                    <li
                      className="d-flex  list-group-item border-0 fw-bold bg-transparent p-0 py-2 px-2"
                      style={{ fontSize: "12px" }}
                    >
                      <i className="bi bi-person-standing me-1"></i>
                      ADULTOS
                    </li>
                  ) : (
                    ""
                  )}
                </ul>
              </div>

              {stock ? (
                <button
                  className={`${
                    me ? "d-none" : "d-md-block"
                  } fs-5 btn btn-custom-amarillo Grifter mt-3 wow bounceInUp py-3 w-100  ${
                    form.fecha ? "" : "disabled"
                  } `}
                  style={{ borderRadius: "10px" }}
                  onClick={() => (window.location.href = "/login")}
                >
                  comprar entradas
                </button>
              ) : (
                <button
                  className={`${
                    me ? "d-none" : "d-md-block"
                  } fs-5 text-white btn btn-custom-naranja Grifter mt-3 wow bounceInUp py-3 w-100 `}
                  style={{ borderRadius: "10px" }}
                  type="button"
                >
                  Entradas agotadas
                </button>
              )}

              {stock ? (
                <button
                  className={`${
                    me ? "d-none d-md-block " : "d-none"
                  } fs-5 btn btn-custom-amarillo Grifter mt-3 wow bounceInUp py-3 w-100  ${
                    form.fecha ? "" : "disabled"
                  } `}
                  style={{ borderRadius: "10px" }}
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  id="modal-comprar-entradas"
                >
                  comprar entradas
                </button>
              ) : (
                <button
                  className={`${
                    me ? "d-none d-md-block " : "d-none"
                  } fs-5 text-white btn btn-custom-naranja Grifter mt-3 wow bounceInUp py-3 w-100 `}
                  style={{ borderRadius: "10px" }}
                  type="button"
                >
                  Entradas agotadas
                </button>
              )}

              <button
                className={`${
                  me ? "d-block d-md-none " : "d-none"
                } fs-5 btn btn-custom-amarillo Grifter mt-3 wow bounceInUp py-3 w-100  ${
                  form.fecha ? "" : "disabled"
                } `}
                style={{ borderRadius: "10px" }}
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasTop-comprar-entradas"
                aria-controls="offcanvasTop-comprar-entradas"
              >
                comprar entradas
              </button>

              {
                <ComprarEntradas
                  setStep={setStep}
                  step={step}
                  entradas={entradas}
                  onClick={onClick}
                  comission={comission}
                  form={form}
                  evento={evento}
                  fechas={evento?.fechasJSON ?? []}
                  label={label}
                  image={image}
                  me={me}
                  loading={loading}
                />
              }

              {
                <OfComprarEntradas
                  setStep={setStep}
                  step={step}
                  entradas={entradas}
                  onClick={onClick}
                  comission={comission}
                  form={form}
                  evento={evento}
                  fechas={evento?.fechasJSON ?? []}
                  label={label}
                  image={image}
                  me={me}
                  setmembresia={membresia}
                  loading={loading}
                />
              }
            </div>
          </div>
        </div>
      </section>

      <section id="ticket-detail" className="pt-100 pb-100">
        <div className="container">
          <div className="row">
            <div
              className="col-12 mb-5 wow bounceInUp"
              dangerouslySetInnerHTML={{ __html: evento.descripcion }}
            ></div>
            <div className="col-12 col-md-6 position-relative wow bounceInUp">
              <h3>FICHA TÉCNICA</h3>
              {evento.ficha_tecnica ? fichaTecnica(evento.ficha_tecnica) : ""}
            </div>
            <div className="col-12 col-md-6 position-relative wow bounceInUp">
              <h3>LINKS</h3>
              {evento.link ? links(evento.link) : null}
            </div>
            {evento.url_youtube ? (
              <div className="col-12 wow bounceInUp mt-5 mb-5">
                <h3>trailers</h3>
                <iframe
                  width="100%"
                  height="500px"
                  src={evento.url_youtube}
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </section>

      <section
        id="ticket-detail"
        className="py-3 border border-bottom-0 border-start-0 border-end-0 border-dark"
      >
        <div className="container">
          <div className="text-center my-5 p-1">
            <div className="d-flex justify-content-between">
              <span></span>
              <div className="text-end">
                <span className="d-block fw-bold">{evento?.email_sitio}</span>
                <span className="d-block ">{`${evento.direccion}, ${evento.localidad} ${evento.provincia}`}</span>
                <span className="d-block ">{evento?.email_sitio}</span>
                <span className="d-block ">{evento?.telefono_sitio}</span>
              </div>
            </div>
            <iframe
              src={
                "https://maps.google.com/?q=" +
                encodeURI(
                  `${evento.direccion}, ${evento.localidad} ${evento.provincia}`
                ) +
                "&z=14&t=m&output=embed"
              }
              style={{ border: "0" }}
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
              height="400px"
              className="my-3 w-100"
            ></iframe>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Entrada;
